class FormHelperCtrl {
  private _validateFn: () => boolean;

  registerValidationFn(fn: () => boolean) {
    this._validateFn = fn;
  }

  isFormValid(): boolean {
    return this._validateFn();
  }
}

export const FormHelper = new FormHelperCtrl();
